import { ConfigurableCard } from "../components/ConfigurableCard";
import { useTemplateContext } from "../provider";
import { VerificationNames } from "shared/types";

export const PayrollVerificationSlice = () => {
  const { readOnly, template, partnerType, setTemplate, verifiedIncome } =
    useTemplateContext();

  if (!template) return null;

  const verificationSchemas = template.verification_schemas[partnerType];

  const verifiedIncomeVerificationSchema =
    verificationSchemas[VerificationNames.VerifiedIncomeVerification];

  const isVerificationEnabled =
    Boolean(verificationSchemas[VerificationNames.IncomeVerification]) &&
    Boolean(verifiedIncomeVerificationSchema);

  const askCustomer =
    Boolean(verifiedIncomeVerificationSchema) &&
    "allow_payroll" in (verifiedIncomeVerificationSchema || {})
      ? verifiedIncomeVerificationSchema?.["allow_payroll"]
      : verifiedIncome["allow_payroll"];

  const togglePayrollEnabled = () => {
    setTemplate({
      ...template,
      verification_schemas: {
        ...template.verification_schemas,
        [partnerType]: {
          ...template.verification_schemas[partnerType],
          [VerificationNames.VerifiedIncomeVerification]: {
            ...verifiedIncomeVerificationSchema,
            allow_payroll: !askCustomer
          }
        }
      }
    });
  };

  return (
    <ConfigurableCard
      title="Payroll verification"
      rightElement={
        <div className="flex gap-4 items-center">
          <img
            className="h-4"
            src="/assets/atomic_logo.svg"
            alt="Atomic logo"
          />
          <img
            className="h-3"
            src="/assets/pinwheel_logo.svg"
            alt="Pinwheel logo"
          />
        </div>
      }
      switchProps={{
        checked: Boolean(askCustomer),
        onChange: togglePayrollEnabled,
        disabled: !isVerificationEnabled || readOnly,
        label: "Allow verification via payroll provider"
      }}
    />
  );
};
